import styled from 'styled-components';

export const HeadingSmall = styled.h3`
    font-weight: bold;
    margin-top: 0px;
    margin-bottom: 0px;
    padding: 16px 0;
    border-bottom: 1px solid #eee;
`;